<template>
  <div>
        <div id="main" class="wh1200">
        <div class="crumbs">
            <div class="name">您现在所在位置：</div>
            <div class="crumbs_box">
                <a href="/">首页</a>
                <a href="javascript:;">杂志阅览</a>
            </div>
        </div>
        <div class="list_content">
            <div class="list_link">
                <div class="home_title"><span class="left">杂志阅览</span></div>
                <div class="link_box">
                    <a  :class="year==item.year?'active':''" @click="selectYear(item.year)" v-for="item in yearList" :key="item" >{{item.year}}年</a>
                </div>
            </div>
            <div class="new_content zhuanti_content zazhi_list">
                <ul class="zazhi_chan_box">
                    <li v-for="item in list" :key="item">
<!--  <img :src="item.face" @click="faceClick(item)" style="" alt="">-->
<!--                        <img :href="JSON.parse(item.contentfile)[0].url" target="_blank" :src="item.face" @click="faceClick(item)" style="" alt="">-->
                        <img :href="magazineDataFormat(item)" target="_blank" :src="item.face" @click="faceClick(item)" style="" alt="">
<!--                         <img :src="item.content" @click="contentClick(item)" style="" alt="">-->
                        <!-- <a href="javascript:;" style="background: url('http://47.115.208.231:8087/uploadFiles/2020-05-31/71189ee2-e3a9-4c6e-a6c1-d5ced485efe1.png') center center no-repeat;"></a> -->
                        <!-- <a href="javascript:;" style="background: url('http://47.115.208.231:8087/uploadFiles/2020-05-31/71189ee2-e3a9-4c6e-a6c1-d5ced485efe1.png') center center no-repeat;"></a> -->
                        <div class="clear"></div>
                    </li>
                    <div class="clear"></div>
                </ul>
               <pages @changPage="changPage" :count="count" style="margin-bottom: 100px;"></pages>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import pages from '@/components/pages'
import axios from 'axios'
import zhazhi from '@/api/modules/zhazhi'
import user from '@/api/modules/user'
export default {
  components: {
    pages
  },
  data () {
    return {
      count: 1,
      sendFrom: {
        'pageSize': '12',
        'page': '1',
        'year': '2020'
      },
	    current:0,
      list: [],
      yearList: [
        {
          year: '2020'
        },
        {
          year: '2019'
        },
        {
          year: '2018'
        },
        // {
        //   year: '2017'
        // },
        // {
        //   year: '2016'
        // }
      ],
      year: '2020'
    }
  },
  created () {
    this.init()
  },
  methods: {
    magazineDataFormat(e) {
      try {
        return JSON.parse(e.facefile)[0].url;
      }
      catch(err) {
        return;
      }
    },
    init () {
      axios({
        method: 'post',
        url: zhazhi.list,
        data: this.sendFrom
      }).then(res => {
        this.count = Number.parseInt(Math.ceil(res.data.count / 10))
        this.list = res.data.list

      })
    },
    selectYear (year,key) {
      this.sendFrom.year = year
	    this.current = key
      this.year = year
      this.init()
    },
    faceClick (item) {
      if (item.facefile) {
        window.open(JSON.parse(item.facefile)[0].url)
        // this.dow(JSON.parse(item.facefile)[0].url)
      }
    },
    contentClick (item) {
      if (item.contentfile) {
        window.open(JSON.parse(item.contentfile)[0].url)
        // this.dow(JSON.parse(item.contentfile)[0].url)
      }
    },

    dow (dowStr) {
      axios({
        method: 'post',
        url: user.blob,
        data: {
          'filename': dowStr
        },
        responseType: 'blob'
      }).then(response => {
        let data = response.data
        if (!data) {
          return
        }
        let url = window.URL.createObjectURL(data)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', dowStr)

        document.body.appendChild(link)
        link.click()
      })
    }

  }
}
</script>

<style scoped>
.clear {
  clear: both;
}
.wh1200 {
  max-width: 1200px;
  margin: 0 auto;
}
.crumbs {
  overflow: hidden;
  height: 50px;
  line-height: 50px;
  background: #eeeeee;
  padding: 0px 20px;
  box-sizing: border-box;
}
.crumbs .name {
  float: left;
  font-size: 14px;
  color: #888888;
}
.crumbs .name a {
  color: #cc0001;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.crumbs .name a:hover {
  color: rgba(204, 0, 1, 0.6);
}
.crumbs .name span {
  color: #333333;
}
.crumbs .crumbs_box {
  float: left;
}
.crumbs .crumbs_box a:hover {
  color: #cc0001;
}
.crumbs .crumbs_box a {
  float: left;
  color: #333333;
  font-size: 14px;
  position: relative;
  padding: 0px 10px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.crumbs .crumbs_box a:after {
  content: '>';
  display: block;
  position: absolute;
  right: -5px;
  top: 0px;
  color: #888888;
}
.crumbs .crumbs_box a:last-child:after {
  display: none;
}
.zhuanti_img img {
  width: 100%;
  display: block;
}
.zhuanti_top {
  padding-left: 40px;
  position: relative;
  box-sizing: border-box;
  margin-top: 20px;
}
.zhuanti_top .zhuanti_title {
  font-size: 36px;
  color: #333333;
  font-weight: bold;
}
.zhuanti_top .zhuanti_text {
  font-size: 16px;
  color: #333333;
  line-height: 36px;
  text-indent: 30px;
  margin-top: 20px;
}
.zhuanti_top:after {
  content: '';
  display: block;
  position: absolute;
  left: 0px;
  top: 5px;
  width: 10px;
  height: 200px;
  background: #cc0001;
}
.jiaodian_box {
  margin-top: 50px;
}
.jiaodian_box .jiaodian_list li {
  margin-top: 20px;
}
.jiaodian_box .jiaodian_list li a {
  display: block;
}
.jiaodian_box .jiaodian_list li a .left_box_img {
  float: left;
  width: 280px;
  height: 200px;
  background-size: cover!important;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.jiaodian_box .jiaodian_list li a .left_box_img:hover {
  transform: translateY(-5px);
  -webkit-transform: translateY(-5px);
  -moz-transform: translateY(-5px);
}
.jiaodian_box .jiaodian_list li a .right_box_text {
  padding-left: 320px;
}
.jiaodian_box .jiaodian_list li a .right_box_text .right_box_con {
  padding-top: 5px;
  padding-bottom: 30px;
  border-bottom: 1px solid #dddddd;
}
.jiaodian_box .jiaodian_list li a .right_box_text .name {
  font-size: 18px;
  color: #333333;
  font-weight: bold;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  padding-left: 20px;
  background: url(../../static/tongzhi_yuan.png) left center no-repeat;
  height: 24px;
}
.jiaodian_box .jiaodian_list li a .right_box_text .name:hover {
  color: #cc0001;
}
.jiaodian_box .jiaodian_list li a .right_box_text .wenzi {
  font-size: 14px;
  color: #888;
  line-height: 30px;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 3;
  height: 90px;
  margin-top: 15px;
}
.jiaodian_box .jiaodian_list li a .right_box_text .time {
  font-size: 14px;
  color: #888;
  margin-top: 15px;
  height: 19px;
}
.jiaodian_box .jiaodian_list li a .right_box_text .time img {
  margin-right: 5px;
}
.fanye {
  font-size: 0px;
  text-align: center;
  margin-top: 40px;
}
.fanye a {
  display: inline-block;
  font-size: 16px;
  color: #111111;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #eeeeee;
  margin: 0px 10px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.fanye a.active {
  background: #cc0001;
  color: #fff;
}
.fanye a.active:hover {
  color: #fff;
}
.fanye a:hover {
  color: #cc0001;
}
.list_content {
  overflow: hidden;
  margin-top: 20px;
}
.list_content .list_link {
  width: 24%;
  float: left;
}
.list_content .list_link .link_box {
  margin-top: 20px;
}
.list_content .list_link .link_box a {
  display: block;
  height: 50px;
  line-height: 50px;
  color: #333333;
  font-size: 18px;
  background: #eeeeee;
  margin-bottom: 1px;
  padding: 0px 40px 0px 20px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  position: relative;
}
.list_content .list_link .link_box a:before {
  content: '';
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #cc0001;
  vertical-align: top;
  position: relative;
  top: 20px;
  margin-right: 20px;
}
.list_content .list_link .link_box a:after {
  content: '';
  display: block;
  width: 7px;
  height: 10px;
  background: url(../../static/link_box_icon.png) center center no-repeat;
  position: absolute;
  right: 20px;
  top: 50%;
  margin-top: -5px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  opacity: 0;
}
.list_content .list_link .link_box a:hover {
  color: #cc0001;
  background: #fff;
}
.list_content .list_link .link_box a:hover:after {
  opacity: 1;
}
.list_content .list_link .link_box a.active:after {
  opacity: 1;
}
.list_content .list_link .link_box a.active {
  background: #fff;
  color: #cc0001;
}
.list_content .zhuanti_content {
  width: 73%;
  float: right;
  margin-top: 30px;
}
.new_content .new_list li {
  padding: 20px 0px;
  border-bottom: 1px solid #ddd;
}
.new_content .new_list li .new_name {
  font-size: 18px;
  color: #333333;
  font-weight: bold;
  padding-left: 50px;
  position: relative;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.new_content .new_list li .new_name:hover {
  color: #cc0001;
}
.new_content .new_list li .new_name:before {
  content: '专题';
  display: block;
  width: 40px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border: 1px solid #cc0001;
  font-size: 14px;
  color: #cc0001;
  position: absolute;
  left: 0px;
  top: 0px;
  font-weight: normal;
}
.new_content .new_list li .new_text {
  font-size: 14px;
  color: #888888;
  line-height: 30px;
  margin-top: 15px;
}
.new_content .new_list li .new_text a {
  color: #cc0001;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.new_content .new_list li .new_text a:hover {
  color: #ef1e1f;
}
.new_content .new_list li .new_bottom {
  overflow: hidden;
  margin-top: 10px;
}
.new_content .new_list li .new_bottom .time {
  font-size: 14px;
  color: #888;
  height: 40px;
  line-height: 40px;
  float: left;
}
.new_content .new_list li .new_bottom .time img {
  margin-right: 5px;
}
.new_content .new_list li .new_bottom .come_in {
  width: 160px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  display: block;
  float: right;
  background: #cc0001;
  border-radius: 5px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.new_content .new_list li .new_bottom .come_in:hover {
  background: #ef1e1f;
}
.new_content.search_result {
  margin-top: 10px;
}
.new_content.search_result .new_list li .new_name {
  padding-left: 20px;
  background: url(../../static/tongzhi_yuan.png) left center no-repeat;
}
.new_content.search_result .new_list li .new_name:before {
  display: none;
}
.list_content .list_link .link_box ul {
  overflow: hidden;
  margin: -0.5px;
}
.list_content .list_link .link_box ul li {
  float: left;
  width: 50%;
  box-sizing: border-box;
  padding: 0.5px;
}
.list_content .list_link .link_box ul li a {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  padding-right: 30px;
}
.list_content .list_link .link_box ul li a:before {
  display: none;
}
.chanyezixun.new_content .new_list li .new_name {
  padding-left: 20px;
  background: url(../../static/tongzhi_yuan.png) left center no-repeat;
}
.chanyezixun.new_content .new_list li .new_name:before {
  display: none;
}
.chanpin_list .list_chan_box {
  overflow: hidden;
  margin: -15px -10px;
}
.chanpin_list .list_chan_box li {
  float: left;
  width: 33.33333333%;
  padding: 15px 10px;
  box-sizing: border-box;
}
.chanpin_list .list_chan_box li a {
  display: block;
}
.chanpin_list .list_chan_box li a .chanpin_img {
  height: 200px;
  background-size: cover!important;
}
.chanpin_list .list_chan_box li a .chanpin_text {
  font-size: 16px;
  color: #333333;
  line-height: 30px;
  height: 60px;
  margin-top: 10px;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 2;
}
.chanpin_list .list_chan_box li a:hover .chanpin_text {
  color: #cc0001;
}
.list_content .zhuanti_content.zazhi_list {
  margin-top: 45px;
}
.zazhi_list .zazhi_chan_box {
  margin: -20px -10px;
}
.zazhi_list .zazhi_chan_box li {
  float: left;
  /*width: 33.33333333%;*/
  width: 25%;
  box-sizing: border-box;
  padding: 20px 10px;
  display: flex;
    align-items: center;
}
.zazhi_list .zazhi_chan_box li img {
  float: left;
  height: 270px;
  /*width: 50%;*/
  width: 100%;
  background-size: cover!important;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  /* border: 1px solid red; */
}
.zazhi_list .zazhi_chan_box li img:hover {
  transform: translateY(-5px);
  -webkit-transform: translateY(-5px);
  -moz-transform: translateY(-5px);
  -moz-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
}
.details_content {
  margin-top: 30px;
}
.details_top .details_title {
  font-size: 24px;
  color: #333333;
  font-weight: bold;
  text-align: center;
}
.details_top .details_xinxi {
  padding: 20px 0px 35px 0px;
  border-bottom: 1px solid #ddd;
}
.details_top .details_xinxi .xinxi_box {
  float: left;
  font-size: 14px;
  color: #888888;
}
.details_top .details_xinxi .xinxi_box img {
  position: relative;
  top: 1px;
  margin-right: 5px;
}
.details_top .details_xinxi .xinxi_box div {
  margin-right: 15px;
  float: left;
}
.details_top .details_xinxi .bdsharebuttonbox {
  float: right;
}
.details_top .details_xinxi .bdsharebuttonbox .share {
  float: left;
  padding-left: 22px;
  font-size: 14px;
  color: #aaaaaa;
  background: url(../../static/share_icon.png) left center no-repeat;
}
.details_top .details_xinxi .bdsharebuttonbox .bshare-custom {
  float: left;
  margin-left: 15px;
}
.details_bottom {
  font-size: 16px;
  color: #333333;
  line-height: 36px;
  margin-top: 30px;
  margin-bottom: 50px;
}
.details_bottom img {
  max-width: 100%;
}
.details_bottom a {
  color: #0658a4;
}
.details_bottom a:hover {
  text-decoration: underline;
}
.biaoqian {
  margin-top: 30px;
  font-size: 14px;
  color: #888888;
  padding-bottom: 30px;
  border-bottom: 1px solid #ddd;
  display: flex;
  align-items: center;
}
.biaoqian img {
  margin-right: 7px;
}
.fanhui_link.tinajia_link:before {
  background: url(../../static/tianjia_icon01.png) center center no-repeat;
  width: 20px;
  height: 20px;
  margin-right: 15px;
  top: 5px;
}
.fanhui_link {
  display: block;
  width: 198px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  color: #0658a4;
  margin: 0 auto;
  margin-top: 40px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.fanhui_link:before {
  content: '';
  display: inline-block;
  background: url(../../static/fanhui.png) center center no-repeat;
  width: 10px;
  height: 15px;
  background-size: cover!important;
  position: relative;
  top: 2px;
  margin-right: 20px;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.fanhui_link:hover {
  border: 1px solid #0658a4;
}
.ziliao_content {
  position: relative;
  padding: 35px 40px 35px 30px;
  height: 100px;
}
.ziliao_content .l_bg {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 5px;
  height: 100%;
  background: url(../../static/zongxiang_img.png) center center;
}
.ziliao_content .r_bg {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 5px;
  height: 100%;
  background: url(../../static/zongxiang_img.png) center center;
}
.ziliao_content .t_bg {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 5px;
  background: url(../../static/hengxiang_bg_img.png) center center;
}
.ziliao_content .b_bg {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 5px;
  background: url(../../static/hengxiang_bg_img.png) center center;
}
.ziliao_content .ziliao_name {
  position: absolute;
  top: -20px;
  left: 0px;
  width: 130px;
  background: #fff;
  font-size: 20px;
  color: #333333;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  padding-left: 5px;
}
.ziliao_content .ziliao_name img {
  position: relative;
  top: 5px;
  margin-right: 7px;
}
.ziliao_content .ziliao_box .ziliao_list {
  margin: 5px 0px;
}
.ziliao_content .ziliao_box .ziliao_list .left {
  float: left;
  font-size: 16px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  color: #333333;
}
.ziliao_content .ziliao_box .ziliao_list .left img {
  position: relative;
  top: 6px;
  margin-right: 10px;
}
.ziliao_content .ziliao_box .ziliao_list .left:hover {
  color: #0658a4;
}
.ziliao_content .ziliao_box .ziliao_list .right {
  float: right;
  width: 118px;
  height: 28px;
  line-height: 28px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  color: #0658a4;
  text-align: center;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.ziliao_content .ziliao_box .ziliao_list .right img {
  margin-right: 5px;
}
.ziliao_content .ziliao_box .ziliao_list .right:hover {
  border: 1px solid #0658a4;
}
.shangxia_content {
  margin-top: 15px;
}
.shangxia_content .shangxia_box {
  padding: 12px 0px;
}
.shangxia_content .shangxia_box .fanye_name {
  font-size: 14px;
  color: #cc0001;
  margin-bottom: 10px;
}
.shangxia_content .shangxia_box .fanye_name img {
  position: relative;
  vertical-align: top;
  top: 7px;
  margin-right: 7px;
}
.shangxia_content .shangxia_box a {
  display: table;
}
.shangxia_content .shangxia_box a div {
  font-size: 18px;
  color: #333333;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
  max-width: 700px;
}
.shangxia_content .shangxia_box a:hover div {
  color: #cc0001;
}
.chanpin_details_top {
  overflow: hidden;
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
}
.chanpin_details_top .img {
  float: left;
  width: 280px;
  height: 200px;
  background: url(../../static/left_box_img01.jpg) center center no-repeat;
  background-size: cover!important;
}
.chanpin_details_top .right_content {
  padding-left: 320px;
}
.chanpin_details_top .right_content .chanpin_name {
  color: #333333;
  font-size: 24px;
  font-weight: bold;
}
.chanpin_details_top .right_content .chanpin_text {
  color: #333333;
  font-size: 16px;
  line-height: 36px;
  margin-top: 20px;
}
.shangxia_content.shangxia_border {
  border-top: 1px solid #ddd;
  padding-top: 15px;
  margin-top: 40px;
}
.hide_content {
  display: none;
}
.home_title {
  font-size: 20px;
  border-bottom: 1px solid #cc0001;
  font-weight: bold;
  height: 45px;
  line-height: 45px;
  overflow: hidden;
}
.home_title .left {
  display: block;
  position: relative;
  color: #333333;
  float: left;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.home_title .left:before {
  content: "";
  display: block;
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 4px;
  background: #cc0001;
}

</style>



// WEBPACK FOOTER //
// src/pages/zhazhi/zhazhi.vue